import { useTranslation } from 'react-i18next';
import { convertSecondsToTime } from 'utils/timeHelper';
import classNames from 'classnames';
import { Flex, Typography, Skeleton } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';

import s from './styles.module.scss';

import type { ModuleType } from 'infrastructure/enums';
import type { FC } from 'react';

const { Text } = Typography;

interface ModuleTimeProps {
  clinicTime?: number;
  totalTime?: number;
  module: ModuleType;
  accent?: boolean;
  isLoading?: boolean;
}

const ModuleTime: FC<ModuleTimeProps> = ({
  clinicTime,
  totalTime,
  module,
  accent,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <Flex vertical className={s['time-body']}>
      <Text data-module={module} className={s['time-body-module']}>
        {module.toUpperCase()}
      </Text>
      <Flex
        className={s['time-body-clinic']}
        align="center"
        justify="space-between"
      >
        <Text className={s['time-body-title']}>{t('controls.clinic')}</Text>
        {isLoading ? (
          <Skeleton.Node active className={s['skeleton-time']} />
        ) : (
          <Text
            className={s['time-body-count']}
            data-cy="clinic-interactive-time"
          >
            {convertSecondsToTime(clinicTime)}
          </Text>
        )}
      </Flex>
      <Flex
        className={classNames(s['time-body-total'], {
          [s.accent]: accent,
        })}
        align="center"
        justify="space-between"
      >
        <Flex
          align="center"
          gap={4}
          className={classNames(s['time-body-title'], {
            [s.accent]: accent,
          })}
        >
          {t('controls.total')}
          {accent && <ExclamationCircleFilled />}
        </Flex>
        {isLoading ? (
          <Skeleton.Node active className={s['skeleton-time']} />
        ) : (
          <Text
            className={classNames(s['time-body-count'], {
              [s.accent]: accent,
            })}
            data-cy="total-interactive-time"
          >
            {convertSecondsToTime(totalTime)}
          </Text>
        )}
      </Flex>
    </Flex>
  );
};
export default ModuleTime;
